// extracted by mini-css-extract-plugin
module.exports = {"scroll":"seo-table_scroll__Z_lwu","heading":"seo-table_heading__OaJW2","table":"seo-table_table__BAHU0"};